import React, { useContext, useEffect } from 'react'
import CheckerNotMove from '../cmp/CheckerNotMove'
import Filter from '../cmp/Filter'
import EditCtrl from '../cmp/EditCtrl.js'
import icon from '../icons.svg'

import { dataContext, localestr, toText, isValidDate, strPeriod, exportToExcel } from '../utils.js'

function RepProduction({ data = undefined, actions }) {
  let wndData = ''
  let content = ''
  let content1 = ''
  let content2 = ''
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const context = useContext(dataContext)
  const getSettings = context.getSettings
  const setSettings = context.setSettings
  const loaddat = context.loaddata
  const usersettings = getSettings()
  const msg = context.msg
  const inputRange = context.inputRange
  const OpenTabObject = context.OpenTabObject
  const setPosition = context.setPosition
  const position = context.getPosition('RepProduction')

  let from = new Date()
  from.setHours(0, 0, 0, 0)
  let to = new Date()
  to.setHours(23, 59, 59, 999)

  let grouping = [{ name: localestr('Продукція'), value: 'product_id', checked: true, type: 'catGoods' },
  { name: localestr('Інгредієнти'), value: 'ingredient_id', checked: true, type: 'catGoods' }]


  const filterData = [
    { caption: localestr('Продукція'), dataId: 'product_id', typeVal: 'catGoods' },
    { caption: localestr('Підрозділ'), dataId: 'department_id', typeVal: 'catDepartments' },
    { caption: localestr('Інгредієнти'), dataId: 'ingredient_id', typeVal: 'catGoods' },
  ]


  if (usersettings) {
    if (usersettings.repProduction) {
      if (usersettings.repProduction.from) from = new Date(usersettings.repProduction.from)
      if (usersettings.repProduction.to) to = new Date(usersettings.repProduction.to)
      if (usersettings.repProduction.grouping) grouping = usersettings.repProduction.grouping
    }
  }
  if (wndData.grouping) grouping = wndData.grouping
  if (wndData.from) to = wndData.from
  if (wndData.to) to = wndData.to


  function groupingHandler(d) {
    setWndData({ ...wndData, grouping: d })
    setSettings({ repProduction: { from, to, grouping: d } })
  }

  function filterHandler(d) {
    setWndData({ ...wndData, filter: d })
    //setSettings({repProduction:{from,to,grouping:d}})
  }

  function range(frm, to_) {
    //let showRange=!wndData.showRange
    let froml = from
    let tol = to
    if (isValidDate(frm)) froml = frm
    if (isValidDate(to_)) tol = to_
    if (froml > tol) {
      msg(localestr('Не правильний діапазон дат'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
      return
    }
    /*let Datal=table
    if (froml!==from || tol!==to) {
        Datal=undefined
    }*/
    /*setWndData({...wndData,showRange,from:froml,to:tol})
    if (!showRange) setSettings({repProduction:{from:froml,to:tol,grouping}})*/
    setWndData({ ...wndData, from: froml, to: tol })
    setSettings({ repProduction: { from: froml, to: tol, grouping } })
  }

  function getFolders(d) {
    let ret = ''
    if (!d) return ret
    ret = ",'" + d.id + "'"
    if (d.data) d.data.forEach(el => ret += getFolders(el))
    return ret
  }

  function loadData(d) {
    setPosition('RepProduction', 0)
    if (d) {
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }

      let data1 = null
      if(d.data1) {
        data1=d.data1.map(el => ({ ...el, qtt:parseFloat(el.qtt)||0, am: parseFloat(el.am)||0 }))
      }
      let data2 = null
      if(d.data2) {
        data2=d.data2.map(el => ({ ...el, qtt:parseFloat(el.qtt)||0, am: parseFloat(el.am)||0 }))
      }


      //const item = { id: 'totals', type: 'totals', name: localestr('Разом'), level: -1, keys: [], sum_s: ttl_sum_s, sum_d: ttl_sum_d, sum_c: ttl_sum_c }
      //data.push(item)
      //data = data.filter(el => el.name !== 'ignore')
      const caption = localestr('Звіт про випуск продукції за період ') + new Date(d.from).toLocaleDateString() + ' - ' + new Date(d.to).toLocaleDateString() + ''
      setWndData({ ...wndData, content: { caption,  filters: d.filters.map(el => el.caption), prod_separate: d.prod_separate, data1, data2 } })

    } else {
      let groups = []
      let froml = from.toISOString().substring(0, 19) + 'Z'
      let tol = to.toISOString().substring(0, 19) + 'Z'
      let tz = to.getTimezoneOffset()
      if (tz < 0) tz = '%2B0' + (tz / -60) + ':00'
      else tz = '-0' + (tz / 60) + ':00'
      for (let i = 0; i < grouping.length; i++) if (grouping[i].checked) groups.push(grouping[i].value)
      if (groups.length === 0) {
        msg(localestr('Треба вибрати хоча б одне групування'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
        return
      }
      let filters = []
      if (wndData.filter) {
        filters = wndData.filter.filter(el => el.compare)
        for (let i = 0; i < filters.length; i++) {
          let new_el = { value: filters[i].dataId }
          if (filters[i].compare === '=' || filters[i].compare === '>' || filters[i].compare === '<') {
            if (!filters[i].value) new_el.compare = ' IS NULL'
            else if (filters[i].value.id) new_el.compare = '' + filters[i].compare + "'" + filters[i].value.id + "'"
            else new_el.compare = '' + filters[i].compare + "'" + filters[i].value + "'"
            new_el.caption = filters[i].caption + ' ' + filters[i].compare + ' ' + toText(filters[i].value)
          } if (filters[i].compare === '<>') {
            if (!filters[i].value) new_el.compare = ' IS NOT NULL'
            else if (filters[i].value.id) new_el.compare = "!='" + filters[i].value.id + "'"
            else new_el.compare = '' + filters[i].compare + "'" + filters[i].value + "'"
            new_el.caption = filters[i].caption + ' ' + filters[i].compare + ' ' + toText(filters[i].value)
          } else if (filters[i].compare === 'lk') {
            new_el.compare = "LIKE('%" + filters[i].value + "%')"
            new_el.caption = filters[i].caption + ' ' + localestr('містить') + ' ' + toText(filters[i].value)
          }
          else if (filters[i].compare === 'nlk') {
            new_el.compare = "NOT LIKE('%" + filters[i].value + "%')"
            new_el.caption = filters[i].caption + ' ' + localestr('не містить') + ' ' + toText(filters[i].value)
          }
          else if (filters[i].compare === 'in_f') {
            new_el.value = filters[i].dataId + 'p'
            new_el.compare = 'IN(' + getFolders(filters[i].value).substring(1) + ')'
            new_el.caption = filters[i].caption + ' ' + localestr('в папці') + ' ' + toText(filters[i].value)
          } else if (filters[i].compare === 'nin_f') {
            new_el.value = filters[i].dataId + 'p'
            new_el.compare = 'NOT IN(' + getFolders(filters[i].value).substring(1) + ')'
            new_el.caption = filters[i].caption + ' ' + localestr('не в папці') + ' ' + toText(filters[i].value)
          }
          filters[i] = new_el
        }
      }
      loaddat('action=repProduction&data=' + JSON.stringify({ from: froml, to: tol, tz, groups, filters, prod_only: wndData.prod_only||0, prod_separate: wndData.prod_separate||0 }), null, (dt) => { loadData(dt) })
    }
  }

  function specification(obj) {
    if (!obj) return
    //console.log(obj)
    OpenTabObject(obj.type, obj.id)
  }

  if (wndData.content) {
    let filters = null
    if (wndData.content.filters.length) {
      filters = wndData.content.filters.map((el, idx) => {
        return <p key={idx}>{el}</p>
      })
      filters = <div className='rep_filters'>{filters}</div>
    }
    if(wndData?.content?.data1?.length){
      const items = wndData.content.data1.map((el, idx) => {
        const sum_q = el.qtt ? el.qtt.toFixed(3) : ''
        const sum_s = el.am ? el.am.toFixed(2) : ''
        return <tr tabIndex='0' key={idx}>
          <td style={{ cursor: 'pointer' }} className={'rep_grp0'} onDoubleClick={() => specification({type:'catGoods',id:el.prod_id})}>{el.prod_name}</td>
          <td style={{ cursor: 'pointer' }} className={'rep_grp0'} onDoubleClick={() => specification({type:'catDepartments',id:el.dep_id})}>{el.dep_name}</td>
          <td className={'rep_grp0 rep_number' + (el.sum_s < 0 ? ' red' : '')}>{sum_q}</td>
          <td className={'rep_grp0 rep_number' + (el.sum_d < 0 ? ' red' : '')}>{sum_s}</td></tr>
      })
      content1 = <><h4 style={{padding:'0',margin:'0'}}>{localestr('Випуск продукції')}</h4><table className='rep_table'><thead><tr><th>{localestr('Продукція')}</th><th>{localestr('Підрозділ')}</th><th>{localestr('Кількість')}</th><th>{localestr('Сума')}</th></tr></thead><tbody>{items}</tbody></table></>
    }
    if(wndData?.content?.data2?.length){
      const items = wndData.content.data2.map((el, idx) => {
        const sum_q = el.qtt ? el.qtt.toFixed(3) : ''
        const sum_s = el.am ? el.am.toFixed(2) : ''
        if(wndData.content.prod_separate)
        return <tr tabIndex='0' key={idx}>
          <td style={{ cursor: 'pointer' }} className={'rep_grp0'} onDoubleClick={() => specification({type:'catGoods',id:el.good_id})}>{el.good_name}</td>
          <td style={{ cursor: 'pointer' }} className={'rep_grp0'} onDoubleClick={() => specification({type:'catDepartments',id:el.dep2_id})}>{el.dep2_name}</td>
          <td style={{ cursor: 'pointer' }} className={'rep_grp0'} onDoubleClick={() => specification({type:'catGoods',id:el.prod_id})}>{el.prod_name}</td>
          <td className={'rep_grp0 rep_number' + (el.sum_s < 0 ? ' red' : '')}>{sum_q}</td>
          <td className={'rep_grp0 rep_number' + (el.sum_d < 0 ? ' red' : '')}>{sum_s}</td></tr>
        else
        return <tr tabIndex='0' key={idx}>
          <td style={{ cursor: 'pointer' }} className={'rep_grp0'} onDoubleClick={() => specification({type:'catGoods',id:el.good_id})}>{el.good_name}</td>
          <td style={{ cursor: 'pointer' }} className={'rep_grp0'} onDoubleClick={() => specification({type:'catDepartments',id:el.dep2_id})}>{el.dep2_name}</td>
          <td className={'rep_grp0 rep_number' + (el.sum_s < 0 ? ' red' : '')}>{sum_q}</td>
          <td className={'rep_grp0 rep_number' + (el.sum_d < 0 ? ' red' : '')}>{sum_s}</td></tr>
      })
      if(wndData.content.prod_separate)
      content2 = <><h4 style={{padding:'0',margin:content1?'12px 0 0 0':'0'}}>{localestr('Витрата інгредієнтів')}</h4><table className='rep_table'><thead><tr><th>{localestr('Інгредієнт')}</th><th>{localestr('Підрозділ')}</th><th>{localestr('Продукція')}</th><th>{localestr('Кількість')}</th><th>{localestr('Сума')}</th></tr></thead><tbody>{items}</tbody></table></>
      else
      content2 = <><h4 style={{padding:'0',margin:content1?'12px 0 0 0':'0'}}>{localestr('Витрата інгредієнтів')}</h4><table className='rep_table'><thead><tr><th>{localestr('Інгредієнт')}</th><th>{localestr('Підрозділ')}</th><th>{localestr('Кількість')}</th><th>{localestr('Сума')}</th></tr></thead><tbody>{items}</tbody></table></>
    }

    //console.log(wndData.content.data)
    content = <><h3 className='rep_caption'>{wndData.content.caption}</h3>{filters}
    </>
  }

  const setPos = target => {
    if (!target) return
    //if(!position) return
    target.scrollTop = position
  }

  //const showRange = wndData.showRange ? <RangeForm from={from} to={to} setRng={range}/> : ''  //+
  let btn2 = null
  if (content) {
    btn2 = <div className='no-print' style={{ position: 'absolute', top: '5px', right: '5px', display: 'flex', gap: '5px' }}>
      <div onClick={e => window.print()} style={{ cursor: 'pointer', }}>
        <img style={{ width: '24px', height: '24px' }} src={icon + '#b503'} alt='' />
      </div>
      <div style={{ cursor: 'pointer', }} onClick={() => exportToExcel(wndData)}>
        <img style={{ width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
      </div>

    </div>
  }

  useEffect(() => {
    if (wndData && wndData.run) setTimeout(loadData, 200)
    // eslint-disable-next-line 
  }, [])

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row' }}>
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className='toolBar no-print'>
          <div tabIndex='0' onClick={() => { loadData() }} onKeyUp={(e) => { if (e.key === 'Enter') loadData() }}
            style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
            <img style={{ width: '12px', height: '24px', padding: '2px', verticalAlign: 'middle' }} src={icon + '#run'} alt={localestr('Вивести')} />&nbsp;
            {localestr('Вивести')}
          </div>
          <div tabIndex='0' onClick={() => { inputRange(from, to, range) }} onKeyUp={(e) => { if (e.key === 'Enter') range() }}
            style={{ textAlign: 'center', lineHeight: '30px', height: '30px', width: '192px', padding: '0px 20px 0 2px', userSelect: 'none', cursor: 'pointer', color: '#FFF', background: 'url(' + icon + '#btn185v) no-repeat', backgroundSize: '192px 30px', boxSizing: 'border-box', position: 'relative', wordBreak: 'break-all' }}>
            {strPeriod(from, to)}
            <img style={{ width: '24px', height: '24px', position: 'absolute', top: '5px', right: '4px' }} src={icon + '#cal_w'} alt={localestr('Інтервал дат')} />
          </div>
          <div style={{ flexGrow: '10' }}></div>
        </div>
        <div className='reportContent' style={{ position: 'relative' }} ref={el => { setPos(el) }} onScroll={e => setPosition('RepProduction', e.target.scrollTop)}>{content}{content1}{content2}{btn2}</div>
      </div>
      <div className='reportTuns no-print'>
        <CheckerNotMove caption={localestr('Групування')} data={grouping} setData={groupingHandler} />
        <div style={{fontSize:'small',marginLeft:'3px'}}>
          <EditCtrl Capt={localestr('Аналізувати тільки документи "Випуск"')} Value={wndData.prod_only} typeVal={'check'} setVal={d=>setWndData({...wndData,prod_only:d})} width1='152' width2='15' />
          <EditCtrl Capt={localestr('Розділяти інгредієнти по видам продукції')} Value={wndData.prod_separate} typeVal={'check'} setVal={d=>setWndData({...wndData,prod_separate:d})} width1='152' width2='15' />

        </div>
        <Filter filterData={filterData} filter={wndData.filter} setFilter={filterHandler} />
      </div>
      {/*showRange*/}
    </div>
  )

}


export default RepProduction